/* @flow */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { action } from 'mobx';

import Localizable from 'lib/intl/localizable';

import { Form, Field } from 'lib/form/form';
import withDialog from 'lib/alerts/with-dialog';

import withStackViewForm from 'four-nets/ui/with-stack-view-form';
import SubmitButtonView from 'four-nets/ui/submit-button/submit-button-view';
import TextAreaView from 'four-nets/ui-v2/form/text-area/text-area';
import { ValueFieldData } from 'lib/form/value-field-data';
import Styled from 'styled';
import FieldWithLabelView from 'four-nets/ui/form/field-with-label-view';
import defaultStyles from './new-comment-complaint-view.scss';
import FormView from './form/form-view';

export class NewCommentComplaintViewModel {
    comment: Comment;

    constructor(options: { comment: Comment }) {
        const { comment } = options;

        this.comment = comment;
    }

    handleSubmit = ({
        data,
    }: {
        data: {
            message: ?string,
        },
    }) => {
        const { message } = data;
        return this.comment.complain({ message });
    };

    @action setupForm = () => {
        const form = new Form({
            field: {
                message: new Field({
                    data: new ValueFieldData({
                        value: null,
                    }),
                }),
            },
            handleSubmit: this.handleSubmit,
        });

        form.field.get('message').data.setValue({ value: '' });

        return form;
    };
}

@Localizable()
@withStackViewForm({
    hideAction: true,
    title: <FormattedMessage id='FORUM_FORM_TITLE_NEW_COMPLAINT' />,
})
@withDialog
@Styled(defaultStyles)
@observer
class NewCommentComplaintView extends React.Component {
    render() {
        const {
            submit,
            form,
            styles,
            intl: { _ },
        } = this.props;
        const { valid, dirty } = form;

        return (
            <FormView form={form} submitOnEnter={false} submit={submit}>
                <FieldWithLabelView
                    field={
                        <div>
                            <TextAreaView field={form.field.get('message')} type='text' />
                            <p className={styles.requiredLabel}>
                                * &nbsp;
                                {<FormattedMessage id='FORM_TEXT_FIELD_NOT_REQUIRED' />}
                            </p>
                            <div className={styles.field}>
                                <SubmitButtonView disabled={!(valid && dirty)} onClick={submit}>
                                    <span className={styles.label}>
                                        {<FormattedMessage id='FORUM_BUTTON_LABEL_SUBMIT_COMPLAINT' />}
                                    </span>
                                </SubmitButtonView>
                            </div>
                        </div>
                    }
                    label={<FormattedMessage id='FORM_FIELD_LABEL_COMPLAINT_REASON' />}
                />
            </FormView>
        );
    }
}

export default NewCommentComplaintView;
